import React, { useContext } from "react";
import Notification from "./common/Notification";
import UserMenu from "./common/UserMenu";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Parser from "html-react-parser";
import AuthContext from "../store/auth-context";
import { useTranslation } from "react-i18next";

function NeedHelp() {
  const authCtx = useContext(AuthContext);
  const [t] = useTranslation();
  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  const faqList = [
    {
      title: t("Do I need to register to use the Portal?"),
      description: t(
        "Yes, Registration is mandatory. Register with an active phone number and a valid ID proof."
      ),
    },
    {
      title: t("How do I book an appointment?"),
      description: t(
        "We have provided multiple ways to help you book an appointment with our specialists. You can book an appointment via:\n<ul><li>Doctors > Search Doctor > Book</li><li>Doctors > Select Specialty > Book</li><li>Manage Appointment > Click + to book an appointment</li><li>Locations > Doctors > Book</li></ul>"
      ),
    },
    {
      title: t("Where are the hospitals Located?"),
      description: t(
        "We are located across UAE eg. Dubai, Abu Dhabi, Sharjah, etc.. All locations can be viewed in the Locations section."
      ),
    },
    {
      title: t("What are Health Packages?"),
      description: t(
        "Health Packages offer you a curated set of treatment/procedures at amazing prices."
      ),
    },
    {
      title: t("How do I calculate my BMI?"),
      description: t(
        "We have you covered here too! Go to Health Tap > BMI Calculator"
      ),
    },
    {
      title: t("Can I avail insurance at Burjeel?"),
      description: t(
        "Visit the Insurance Partners section to confirm your Insurance provider’s presence. We would also suggest checking with the hospital of your choice for the same information as we have multiple branches."
      ),
    },
    {
      title: t("Where do I view diagnostic reports?"),
      description: t(
        "All your Diagnostic Reports are in the Diagnostic Reports tab."
      ),
    },
    {
      title: t("How do I manage my booked appointments?"),
      description: t(
        "You can visit the Manage Appointments section to view your upcoming appointments."
      ),
    },
    {
      title: t("Where do I add my family members?"),
      description: t("Go to Family Members > Add Members"),
    },
    {
      title: t("How do I reach out for other queries?"),
      description: t(
        "You can always call us at 800 55 or drop an email to info@burjeel.com for any queries"
      ),
    },
  ];

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        <div className="d-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>
          <h3 className="fs-18-24">{t("Need Help?")}</h3>
          <div
            className={`${
              authCtx.selectedLanguage === "en" ? "ms-auto" : "mr-auto"
            } mw-90px`}
          >
            <Notification />
            <UserMenu />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-8 ">
            <div className="card border-0 shadow-sm rounded-1rem overflow-hidden">
              <div className="card-body p-4">
                <div className="mb-2 t-n1 position-relative">
                  <i className="material-icons-outlined t-8 position-relative">
                    call
                  </i>{" "}
                  <span className="ms-3">
                    {t("24hrs Helpline Number 800 55")}
                  </span>{" "}
                </div>
                <div className="t-n1 position-relative">
                  <i className="material-icons-outlined t-8 position-relative">
                    email
                  </i>{" "}
                  <span className="ms-3">
                    {localStorage.getItem("brandName") === "burjeel"
                      ? "info@burjeel.com"
                      : localStorage.getItem("brandName") === "medeor"
                      ? "info.auh@medeor.ae"
                      : "info@lifecarehospital.ae"}
                  </span>{" "}
                </div>
              </div>
              <div className="py-2 px-3 bg-dark bg-opacity-10 fs-18 fw-bold">
                {t("Frequently Asked Questions")}
              </div>
              {faqList &&
                faqList.map((item, index) => (
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography className="fw-600">{item.title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {Parser(`<Typography>
                    ${item.description}
                  </Typography>`)}
                    </AccordionDetails>
                  </Accordion>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NeedHelp;
